
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/projected-openings",
      function () {
        return require("private-next-pages/[region]/projected-openings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/projected-openings"])
      });
    }
  